import React, { useCallback, useContext, useState, useEffect} from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import { Currency as CurrencyField, FieldLinkComponent } from "gw-components-platform-react";
import { Link ,withRouter} from "react-router-dom";
import { FieldValue, ModalNextContext } from "@jutro/components";
import { IntlContext } from "@jutro/locale";
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import moment from 'moment';
import PayrollService from "../../../capabilities/cpmi-capability-payroll/services/PayrollService";
import metadata from "./PayrollReportingTable.metadata.json5";
import styles from "./PayrollReportingTable.module.scss";
import messages from "./PayrollReportingTable.messages";




import { Button } from '@jutro/legacy/components';




function PayrollReportingTable(props) {
    const { payrollData, appValue,termperiod,policyNumber,modalContext,updatePayrollTable, policyStatus } = props;
    // const { showAlert } = useContext(ModalNextContext);
    const ModalNext = useContext(ModalNextContext);

    const [showHideVoidRedo,setShowHideVoidRedo] = useState(false);
    //  const [enabledDisableVoidRedo,setEnabledDisable] = useState(false);
    const { authHeader } = useAuthentication();
    const intl = useContext(IntlContext);
    const {history}=props;

    const getFormattedCurrency = (item, index, property) => {
        if (item.totalCost === undefined) {
            return " ";
        }
        return renderFormattedCurrencyField(item[property.id]);
    };

    const renderFormattedCurrencyField = (item, index) => {
        return (
            <div className={styles.currencyContainer}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={item}
                    readOnly
                    hideLabel
                />
            </div>
        );
    };

    useEffect(()=>{

    },[showHideVoidRedo])

      



    const getAction = useCallback((item, index, property) => {
        
        if (!item.hasInProgressReportEdited && item.reportStatus === "In Progress" && item.reportCompletionDate !== "Incomplete")
        {
            if(appValue==="PE")
            {
                let pathValue = `/payroll-reporting/startpayroll`;

                if(props.lineOfBusinessCode ==="GL7GeneralLiability"){
                    pathValue = `/payroll-reporting/startpayrollGL`
                }else{
                    pathValue = props.location.pathname
                }

                const startPayrollPE =()=> {
                    history.push({
                        pathname: pathValue,
                        
                        state: {
                            jobNumber:item.jobNumber,payrollFlag:"Start Payroll",page:"Start",item:item,termperiod:termperiod,appValue:appValue,policyNumber:policyNumber
                        },
                        peMainPayrollPath:props.location.pathname
                    })
                };
                return (
                    <>

                        {
                            policyStatus !== "In Force" && policyStatus !== "Pending Cancellation" ?
                                ""
                                : <Button
                                onClick={startPayrollPE}
                                className={styles.editButton}
                            >
                                Start Payroll Report
                                
                            </Button>
                        }
                    </>
                );                
                
            };
            if(appValue==="CE")
            {  
                let pathValue = `/payroll-reporting/startpayroll`;
                if(props.lineOfBusinessCodeValue ==="GL7Line"){
                    pathValue = `/payroll-reporting/startpayrollGL`
                }     
                if(props.lineOfBusinessCodeValue ==="CA7Line"){
                    pathValue = `/payroll-reporting/startpayrollCA`
                }   
                if(props.lineOfBusinessCodeValue ==="MELLine"){
                    pathValue = `/payroll-reporting/startpayrollMEL`
                }   
                const startPayroll=()=>{
                    history.push({
                        pathname: pathValue,
                        state: {
                            jobNumber:item.jobNumber,payrollFlag:"Start Payroll",page:"Start",termperiod:termperiod,appValue:appValue
                        },
                    })

                }
                return (
                    <>

                    {
                        policyStatus !== "In Force" && policyStatus !== "Pending Cancellation" ?
                            ""
                            : <Button onClick={startPayroll} className={styles.editButton}>
                                Start Payroll Report
                            </Button>
                    }
                </>
                    
                )
               
            }
        }
        if ((item.hasInProgressReportEdited && item.reportStatus === "In Progress") || (item.reportStatus === "In Progress" && item.reportCompletionDate === "Incomplete"))
        {
            if(appValue==="PE")
            {
                let pathValue = `/payroll-reporting/startpayroll`;

                if(props.lineOfBusinessCode ==="GL7GeneralLiability"){
                    pathValue = `/payroll-reporting/startpayrollGL`
                }else{
                    pathValue = props.location.pathname
                }
                const editPayrollPE =()=> {
                    history.push({
                        pathname: pathValue,
                        state: {
                            jobNumber:item.jobNumber,payrollFlag:"Edit Payroll",page:"Start",item:item,termperiod:termperiod,appValue:appValue,policyNumber:policyNumber
                        },
                        peMainPayrollPath:props.location.pathname
                    })
                };
                return (
                    <>

                    {
                        policyStatus !== "In Force" && policyStatus !== "Pending Cancellation" ?
                            ""
                            : <Button
                            id="editPayrollPE"
                            onClick={editPayrollPE}
                            type="outlined"
                            className={styles.editButton}
                            >
                                Edit Payroll Report
                            </Button>
                    }
                </>                      
                );
            };
            if(appValue==="CE")
            { 
                let pathValue = `/payroll-reporting/startpayroll`;
                if(props.lineOfBusinessCodeValue ==="GL7Line"){
                    pathValue = `/payroll-reporting/startpayrollGL`
                }     
                if(props.lineOfBusinessCodeValue ==="CA7Line"){
                    pathValue = `/payroll-reporting/startpayrollCA`
                }   
                if(props.lineOfBusinessCodeValue ==="MELLine"){
                    pathValue = `/payroll-reporting/startpayrollMEL`
                }               
                const editPayroll=()=>{
                    history.push({
                        pathname: pathValue,
                        state: {
                            jobNumber:item.jobNumber,payrollFlag:"Edit Payroll",page:"Start",termperiod:termperiod,appValue:appValue
                        }
                    })

                }

                return (
                    <>
                    {
                        policyStatus !== "In Force" && policyStatus !== "Pending Cancellation" ?
                            ""
                            : <Button onClick={editPayroll} 
                            type="outlined"
                            className={styles.editButton}
                        >
                            Edit Payroll Report
                        </Button>
                    }
                    </>                    
                )
               
            }
           

        } 

        if(item.reportStatus === "Completed")  
        {
            if(appValue==="PE")
            {
                // setEnabledDisable(true);
                const voidRedoPE =()=> {
                    
                    // e.preventDefault()
                                ModalNext.showConfirm({
                                    title: "Void/Redo the Completed Payroll Report",
                                    message:`Click to confirm that you wish to void your previous payroll entry and redo.
The payroll report will be due immediately.`,
                                    status: 'warning',
                                    cancelButtonText: "Cancel",
                                    confirmButtonText:"Confirm"               
                                }).then(async (results) => {
                                    if (results === 'cancel') {
                                        return _.noop();
                                    }
                                    if(results === 'confirm'){
                                    try {
                                        const voidRedoObj = await PayrollService.revertAndCreateAuditReport([item], authHeader)
                                        updatePayrollTable();
                                        if(voidRedoObj){
                                            setShowHideVoidRedo(true)
                                        }
                                      
                    
                                    } catch (e) {
                                        ModalNext.showAlert({
                                            title: "Error",
                                            message: "Error",
                                            status: 'error',
                                            icon: 'mi-error-outline',
                                            confirmButtonText: "Ok"
                                        }).catch(_.noop);
                                    }
                                    return true;
                                }
                                }, _.noop);
                    
                            };
               
                return (
                    <>

                        {
                            item.reportType === "Premium Report Reversal" || item.canReverseAudit === false || (policyStatus !== "In Force" && policyStatus !== "Pending Cancellation") ?
                                ""
                                : <button
                                        onClick={voidRedoPE}
                                        visible={showHideVoidRedo}
                                        className={styles.voidredoButton}
                                        // disabled={enabledDisableVoidRedo}
                                >
                                    Void/Redo
                                </button>
                        }
                    </>
                );
            };
            if(appValue==="CE")
            {   
                // setEnabledDisable(true);             
                const voidRedoCE=()=>{
                    ModalNext.showConfirm({
                        title: "Void/Redo the Completed Payroll Report",
                        message:`Click to confirm that you wish to void your previous payroll entry and redo.
The payroll report will be due immediately.`,
                        status: 'warning',
                        icon: '',
                        cancelButtonText: "Cancel",
                        confirmButtonText:"Confirm"               
                    }).then(async (results) => {
                        if (results === 'cancel') {
                            return _.noop();
                        }
                        if(results === 'confirm'){
                        try {
                            const voidRedoObj = await PayrollService.revertAndCreateAuditReport([item], authHeader)
                           
                            updatePayrollTable();
                            if(voidRedoObj){
                                setShowHideVoidRedo(true);
                            }
                          
        
                        } catch (e) {
                            ModalNext.showAlert({
                                title: "Error",
                                message: "Error",
                                status: 'error',
                                icon: 'mi-error-outline',
                                confirmButtonText: "Ok"
                            }).catch(_.noop);
                        }
                        return true;
                    }
                    }, _.noop);
                }
                return (
                    <>
                        {
                            item.reportType === "Premium Report Reversal" || item.canReverseAudit === false || (policyStatus !== "In Force" && policyStatus !== "Pending Cancellation") ?
                                ""
                                : <button
                                    onClick={voidRedoCE}
                                    visible={showHideVoidRedo}
                                    className={styles.voidredoButton}
                                    // disabled={enabledDisableVoidRedo}
                                >
                                    Void/Redo
                                </button>
                        }
                    </>
                    // <Button onClick={voidRedoCE} className={styles.voidredoButton}>Void/Redo</Button>
                )
               
            }
        }    
       
        
        if (item.canRequestChange) {
            // if ( item.reportStatus === "Completed" && item.reportType === "Premium Report") {
            if(appValue==="PE")
            {
                const redirectpath = {
                    pathname: props.location.pathname,
                    state: {
                        jobNumber:item.jobNumber,page:"Submit",item:item,termperiod:termperiod,appValue:appValue,policyNumber:policyNumber
                    }
                };
                return (
                    <Link
                        to={redirectpath}
                        // onClick={requestChange}
                        className={styles.gwClaimsLinkContent}
                    >
                        Request Change
                    </Link>
                );
            }
            if(appValue==="CE")
            {
                
                const redirectpath = {
                    pathname: "/payroll-reporting/payrollchange",
                    state: {
                        item:item,
                        appValue:appValue,
                        termperiod:termperiod,
                        
     
                    }
                };
                return (
                    <Link
                        to={redirectpath}
                        className={styles.gwClaimsLinkContent}
                    >
                        Request Change
                    </Link>
                );
            }
           

            
    
           
        }

        return " ";
    }, [ModalNext, appValue, authHeader, history, policyNumber, props.location.pathname, showHideVoidRedo, termperiod, updatePayrollTable]);

    const getReportingPeriod = useCallback((rowData, rowIndex) => {
       const  startDate = intl.formatDate(intl.formatDate(moment(rowData.reportPeriodStart).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' }));
       const endDate = intl.formatDate(intl.formatDate(moment(rowData.reportPeriodEnd).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' }));
        const reportingPeriod = `${startDate} - ${endDate}`;
        return (
            <FieldValue
                id={`effectiveDate_${rowIndex}`}
                value={reportingPeriod}
                hideLabel
                readOnly
            />
        );
    }, []);


    const getFormattedDate = useCallback((item, index, property) => {
       
        if (typeof item[property.id] === "undefined") {
            return " ";
        }

        let pathValue = `/payroll-reporting/startpayroll`;

        if(props.lineOfBusinessCodeValue ==="GL7Line"){
            pathValue = `/payroll-reporting/startpayrollGL`
        }     

        if(props.lineOfBusinessCodeValue ==="CA7Line"){
            pathValue = `/payroll-reporting/startpayrollCA`
        }
   
        if(props.lineOfBusinessCodeValue ==="MELLine"){
            pathValue = `/payroll-reporting/startpayrollMEL`
        }   

        if(item.reportStatus === "In Progress" &&!item.hasInProgressReportEdited && (policyStatus === "In Force" && policyStatus !== "Pending Cancellation")){
            if(appValue==="PE")
            {
                let pathPeValue = `/payroll-reporting/startpayroll`;

                if(props.lineOfBusinessCode ==="GL7GeneralLiability"){
                    pathPeValue = `/payroll-reporting/startpayrollGL`
                }     

                if(props.lineOfBusinessCode ==="CA7CommAuto"){
                    pathPeValue = `/payroll-reporting/startpayrollCA`
                }
        
                if(props.lineOfBusinessCode ==="MaritimeEmployerLiability"){
                    pathPeValue = `/payroll-reporting/startpayrollMEL`
                }
                const pathName = {
                    pathname:pathPeValue,// props.location.pathname,
                    state: {
                        jobNumber:item.jobNumber,page:"Start",item:item,termperiod:termperiod,appValue:appValue,policyNumber:policyNumber,payrollFlag:"Start Payroll"
                    },
                    peMainPayrollPath:props.location.pathname
                };
                return (
                    <Link
                        to={pathName}
                        className={styles.gwClaimsLinkContent}>
                            
                        {moment(item[property.id]).format('MM/DD/YYYY')}
                    </Link>
                );
            };
            
                
            const path = {
                pathname:pathValue,
                state: {
                    jobNumber:item.jobNumber,page:"Start",termperiod:termperiod,payrollFlag:"Start Payroll"
                }
            };
            return (
                <Link
                    to={path}
                    className={styles.gwClaimsLinkContent}>
                    {moment(item[property.id]).format('MM/DD/YYYY')}
                </Link>
            );
            
           
        }
        if (item.hasInProgressReportEdited && item.reportStatus === "In Progress" && (policyStatus === "In Force" && policyStatus !== "Pending Cancellation"))
        {
            if(appValue==="PE")
            {
                let pathPeValue = `/payroll-reporting/startpayroll`;

                if(props.lineOfBusinessCode ==="GL7GeneralLiability"){
                    pathPeValue = `/payroll-reporting/startpayrollGL`
                }     

                if(props.lineOfBusinessCode ==="CA7CommAuto"){
                    pathPeValue = `/payroll-reporting/startpayrollCA`
                }
        
                if(props.lineOfBusinessCode ==="MaritimeEmployerLiability"){
                    pathPeValue = `/payroll-reporting/startpayrollMEL`
                }
                const editPath = {
                    pathname:pathPeValue,
                    state: {
                        jobNumber:item.jobNumber,page:"Start",item:item,termperiod:termperiod,appValue:appValue,policyNumber:policyNumber,payrollFlag:"Edit Payroll"
                    },
                    peMainPayrollPath:props.location.pathname
                };
                return (
                    <Link
                        to={editPath}
                        className={styles.gwClaimsLinkContent}
                        
                    >
                        {moment(item[property.id]).format('MM/DD/YYYY')}
                    </Link>
                );
            };
            if(appValue==="CE")
            {
                
                const editpath = {
                    pathname: pathValue,
                    state: {
                        jobNumber:item.jobNumber,page:"Start",termperiod:termperiod,appValue:appValue,payrollFlag:"Edit Payroll"
                    }
                };
                return (
                    <Link
                        to={editpath}
                        className={styles.gwClaimsLinkContent}
                        
                    >
                        {moment(item[property.id]).format('MM/DD/YYYY')}
                    </Link>
                );
                
    
            
                // return <Button className={styles.editButton}>Edit Report</Button>;
            }

        } 
        return (
            moment(item[property.id]).format('MM/DD/YYYY')
        );
        
        
    }, []);

    const getCompletedDate = useCallback((item, index, property) => {
        if (item.reportCompletionDate === "") {
            return " ";
        }
        if(item.reportCompletionDate==='Incomplete')
        {
            return(
                <span style={{color:"red"}}>Incomplete</span>
            ) 
        }
        return (
            moment(item[property.id]).format('MM/DD/YYYY')
        );
    }, []);

   

    const getCell = useCallback((item, index, property) => {
        return item[property.id];
    }, []);

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: payrollData,
            visible: payrollData && payrollData.length > 0?true:false
        },
        noPolicyMessage:{
            visible: payrollData && payrollData.length === 0?true:false
        }

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getReportingPeriod,
            getFormattedCurrency,
            getCell,
            getFormattedDate,
            getAction,
            getCompletedDate
           
        },
    };

    return <MetadataContent uiProps={metadata.componentContent} overrideProps={overrideProps} {...resolvers} />;
}

PayrollReportingTable.propTypes = {
    payrollData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({})
        })
    }).isRequired,
};

PayrollReportingTable.defaultProps = {};

export default withRouter(PayrollReportingTable);
